/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EmployeeFileFieldsOneOf { 
    deleted?: boolean;
    deletedOn?: boolean;
    deletedBy?: boolean;
    createdOn?: boolean;
    modifiedOn?: boolean;
    createdBy?: boolean;
    modifiedBy?: boolean;
    id?: boolean;
    userId?: boolean;
    companyId?: boolean;
    catalogId?: boolean;
    originalName?: boolean;
    storedName?: boolean;
    mimeType?: boolean;
    fileSize?: boolean;
    filePath?: boolean;
    isEncrypted?: boolean;
    encryptionIv?: boolean;
    encryptionAuthTag?: boolean;
    checksum?: boolean;
    encryptedDek?: boolean;
    dekIv?: boolean;
    dekAuthTag?: boolean;
    keyVersion?: boolean;
    isVerified?: boolean;
    status?: boolean;
    rejectionReason?: boolean;
    verifiedBy?: boolean;
    verifiedOn?: boolean;
    notes?: boolean;
}

